// services/narration/templateEngine.ts
import { EvidenceBoundText, EvidenceAtom } from "../../types";

export function bound(text: string, evidence: EvidenceAtom[]): EvidenceBoundText {
  if (!evidence || evidence.length === 0) {
    return { status: "MISSING", text: "", evidence: [] };
  }
  return { status: "COMPLETE", text, evidence };
}
